/**
 * Title case for UI labels: first letter of each word capitalized, rest lowercased.
 * Preserves mixed-case tokens (e.g. RizzTix, iPhone).
 */
export function toTitleCase(value) {
  if (value == null || value === "") return value;
  const text = String(value);
  if (!text.trim()) return text;

  return text.replace(/[^\s]+/g, (word) => {
    if (/^[A-Z]{2,3}$/.test(word)) {
      return word;
    }
    if (
      word.length > 1 &&
      /[A-Z]/.test(word.slice(1)) &&
      /[a-z]/.test(word)
    ) {
      return word;
    }
    if (word.includes("@") || /^https?:\/\//i.test(word)) {
      return word;
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
}
